// src/store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // default localStorage for web
import { combineReducers } from "redux";
// import { PersistGate } from "redux-persist/integration/react";
import Websiteslice from "../Slices/website";

// Configure persist
const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  website: Websiteslice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

const persistor = persistStore(store);

export { store, persistor };
